import { MdOutlineDocumentScanner } from "react-icons/md";

import { CatalogForm } from '../catalog-form';
import { Button } from "../../components";

import styles from './main-content.module.scss';

type MainContentProps = {
    title: string;
    subtitle: string;
    onLogout: () => void;
    isLoggingOut: boolean;
}

export const MainContent: React.FC<MainContentProps> = ({
    title,
    subtitle,
    onLogout,
    isLoggingOut,
}) => {
    return  (
        <div className={styles.mainContentWrapper}>
            <div className={styles.mainContentTextWrapper}>
                <div className={styles.mainContentTitleWrapper}>
                    <div className={styles.mainContentTextIconWrapper}>
                        <MdOutlineDocumentScanner className={styles.mainContentTextIcon}/>
                    </div>
                    <div>
                        <h1 className={styles.mainContentTitle}>{title}</h1>
                        <p className={styles.mainContentSubtitle}>{subtitle}</p>
                    </div>
                </div>
                <Button
                    className={styles.logoutButton}
                    isProcessing={isLoggingOut}
                    onClick={onLogout}
                    size="sm"
                    type="button"
                    variant="outline-secondary"
                >
                    Wyloguj
                </Button>
            </div>
            <CatalogForm/>
        </div>
    ) 
}
